import request from '@/utils/request'
import { BASE_API } from '@/api/baseUrl'

/**
 * 获取数据字典apiGetDictDatas
 * @param {*} params
 */
export function apiLoadDictionary(params) {
  return request({
    url: BASE_API() + '/dictionary/slicedQuerySysDictionaries?page=1&pagesize=200',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
    // data: params
  })
}

/**
 * 获取数据字典明细
 *
 * @param {*} params
 */
export function apiLoadDictionaryDtl(params) {
  return request({
    url: BASE_API() + '/dictionary/querySysDictionaryDetailsByCode',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}




// WEBPACK FOOTER //
// ./src/api/platform/dictionary/index.js